export const DEFAULT_LABEL = 'default';
export const FETCH_LIST_START = 'FETCH_LIST_START';
export const FETCH_LIST_SUCCESS = 'FETCH_LIST_SUCCESS';
export const FETCH_LIST_FAILURE = 'FETCH_LIST_FAILURE';
export const FETCH_ONE_START = 'FETCH_ONE_START';
export const FETCH_ONE_SUCCESS = 'FETCH_ONE_SUCCESS';
export const FETCH_ONE_FAILURE = 'FETCH_ONE_FAILURE';
export const CREATE_ONE_START = 'CREATE_ONE_START';
export const CREATE_ONE_SUCCESS = 'CREATE_ONE_SUCCESS';
export const CREATE_ONE_FAILURE = 'CREATE_ONE_FAILURE';
export const UPDATE_ONE_START = 'UPDATE_ONE_START';
export const UPDATE_ONE_SUCCESS = 'UPDATE_ONE_SUCCESS';
export const UPDATE_ONE_FAILURE = 'UPDATE_ONE_FAILURE';
export const PATCH_ONE_START = 'PATCH_ONE_START';
export const PATCH_ONE_SUCCESS = 'PATCH_ONE_SUCCESS';
export const PATCH_ONE_FAILURE = 'PATCH_ONE_FAILURE';
export const DELETE_ONE_START = 'DELETE_ONE_START';
export const DELETE_ONE_SUCCESS = 'DELETE_ONE_SUCCESS';
export const DELETE_ONE_FAILURE = 'DELETE_ONE_FAILURE';
export const HEAD_START = 'HEAD_START';
export const HEAD_SUCCESS = 'HEAD_SUCCESS';
export const HEAD_FAILURE = 'HEAD_FAILURE';
export const POST_START = 'POST_START';
export const POST_SUCCESS = 'POST_SUCCESS';
export const POST_FAILURE = 'POST_FAILURE';
export const PUT_START = 'PUT_START';
export const PUT_SUCCESS = 'PUT_SUCCESS';
export const PUT_FAILURE = 'PUT_FAILURE';
export const PATCH_START = 'PATCH_START';
export const PATCH_SUCCESS = 'PATCH_SUCCESS';
export const PATCH_FAILURE = 'PATCH_FAILURE';
export const DELETE_START = 'DELETE_START';
export const DELETE_SUCCESS = 'DELETE_SUCCESS';
export const DELETE_FAILURE = 'DELETE_FAILURE';
export const INVALIDATE = 'INVALIDATE';
export const INVALIDATE_FAILURES = 'INVALIDATE_FAILURES';